<template>
  <div class="new-qc-report-detail">
    <!-- 质检项 -->
    <template v-for="(tab, tabIndex) in dataInfo.report && dataInfo.report.reportItem">
      <!-- abNormalNum：异常项数量；normalNum：正常项数量 -->
      <qc-report-tab
        :key="tabIndex"
        :title="tab.checkName"
        :check-num-map="{
          normalNum: tab.normalNum,
          abNormalNum: tab.abNormalNum,
          allPassText: tab.allPassText,
        }"
      >
        <!-- 外观检测图片部分 -->
        <div
          v-if="picList && picList.length && tab.checkName === '外观检测'"
          :slot="'show'"
          class="condition-container"
        >
          <div class="new-example-pics-wrap">
            <ul class="example-pics">
              <li
                v-for="(pic, i) in picList"
                :key="i"
                v-lazy:backgroundImage="$setPicSize(pic, 160, 160)"
                @click="checkBigImage(i)"
              ></li>
            </ul>
          </div>
          <p v-if="tab.groupAbnormalInfo" class="tab-tips">{{ tab.groupAbnormalInfo }}</p>
          <p v-if="tab.groupExplain" class="tab-desc">{{ tab.groupExplain }}</p>
        </div>

        <div slot="toggle">
          <dl v-for="(item, index) in tab.children" :key="index" class="qc-item-sec 4">
            <template v-if="item.values">
              <dd v-for="(sItem, sIndex) in item.values" :key="sItem.valueId">
                <qc-item
                  :title="item.checkName"
                  :qcData="sItem"
                  :item="item"
                  :qcIndex="sIndex"
                  :indicatorGroup="indicatorGroup"
                  @itemClick="showItem(item)"
                ></qc-item>
              </dd>
            </template>
          </dl>
        </div>
      </qc-report-tab>
    </template>
  </div>
</template>
<script>
  import { ImagePreview, Toast } from '@zz-common/zz-ui'
  import QcReportTab from './QcReportTab.vue'
  import QcItem from './Qcitem.vue'
  import Vue from 'vue'
  import { setPicSize } from '@zz-common/zz-utils'
  import native from '@zz-common/native-adapter'

  Vue.use(ImagePreview).use(Toast)
  export default {
    props: {
      dataInfo: {
        type: Object,
        default: () => {},
      },
      picList: {
        type: Array,
        default: () => [],
      },
    },
    components: {
      QcReportTab,
      QcItem,
    },
    computed: {
      $setPicSize() {
        return setPicSize
      },
      iszzt() {
        return native.in('zztong')
      },
      indicatorGroup() {
        const group = []
        //实拍图原图集合
        const pics = (this.dataInfo.report && this.dataInfo.report.samplePics) || []
        if (pics && pics.length) {
          group.unshift({
            title: '实拍图',
            subtitle: '概况',
            total: pics.length,
            data: pics,
          })
        }

        // 瑕疵图相关数据全部在组件内部计算
        const data = this.collectFlawedImg()
        if (Object.keys(data).length) {
          const { detailDrawingIds = {}, detailDrawingNewObj = [], viewImagesList = [] } = data
          const detailDrawed = detailDrawingNewObj.map((item) => item.url) || []
          group.push({
            title: '细节图',
            subtitle: '细节',
            total: detailDrawed.length,
            data: detailDrawed,
            imgDataList: detailDrawingNewObj,
            itemIds: detailDrawingIds,
            viewImagesList,
          })
        }
        return group
      },
      viewImages() {
        const allImages = this.collectFlawedImg()
        return [...this.dataInfo.report.samplePicIds, ...allImages.viewImagesList]
      },
    },
    methods: {
      // 查看质检项
      showItem(data, currentTitle) {
        this.$emit('toggle', {
          ...data,
          newValue: data.value,
          firstItemId: data.firstItemId,
          standardDefines: data.standardDefines || [],
          title: currentTitle || data.title,
          smallEncyclopediaPic: data.smallEncyclopediaPic || '',
        })
      },
      //查看大图
      checkBigImage(selectedIndex) {
        // 转转通场景预览大图包括下载功能
        if (this.iszzt) {
          ImagePreview({
            images: this.picList.map((item) => this.$setPicSize(item, 1000)),
            startPosition: selectedIndex,
            showClose: true,
            adaptApp: true, // 端内
            adaptWeixin: true, // 微信端内
            showDownload: true,
            onDownload: () => {
              native.wrap('saveImageToAlbum')(
                {
                  imageUrl: this.picList[selectedIndex],
                },
                (res) => {
                  const { code, msg } = res
                  if (code === '0') {
                    Toast.success('图片保存成功')
                  } else {
                    Toast.fail(msg)
                  }
                }
              )
            },
          })
        } else {
          ImagePreview({
            images: this.picList.map((item) => this.$setPicSize(item, 1000)),
            startPosition: selectedIndex,
            showClose: true,
            adaptApp: true, // 端内
            adaptWeixin: true, // 微信端内
          })
        }
      },
      treeFindPath(tree, func, path = []) {
        if (!tree) return []
        for (const data of tree) {
          path.push(data.itemId)
          if (func(data)) return path
          if (data.children) {
            const findChildren = this.treeFindPath(data.children, func, path)
            if (findChildren.length) return findChildren
          }
          path.pop()
        }
        return []
      },
      // 获取瑕疵图
      collectFlawedImg() {
        const reportItem = this.dataInfo.report && this.dataInfo.report.reportItem
        const collectArr = []
        const valueIds = []
        const detailDrawingNewObj = [] // $ 存放客户端大图预览的细节图对象
        const viewImagesList = []

        if (reportItem) {
          reportItem.forEach((originTreeItem, originTreeIdex) => {
            if (!originTreeItem.itemId && originTreeItem.children) {
              console.log(originTreeIdex, originTreeItem.children)
              // originTreeItem.children.forEach((mapItem, mapIndex) => {
              originTreeItem.children.forEach((mapItem) => {
                mapItem.children &&
                  mapItem.children.forEach((zItem) => {
                    zItem.firstTitle = mapItem.name || ''
                  })
              })
            }
          })
        }
        const collectObj = {}
        if (collectArr.length) {
          for (let i = 0; i < collectArr.length; i++) {
            collectObj[i] = this.treeFindPath(reportItem, (data) => data.itemId == collectArr[i])
            collectObj[i].push(valueIds[i])
            collectObj[i].shift()
          }
        }
        return {
          detailDrawingIds: collectObj,
          detailDrawingNewObj,
          viewImagesList,
        }
      },
    },
  }
</script>
<style lang="scss" scoped>
  @import '@zz-common/zz-ui/lib/style/mixins/hairline.scss';
  @import '@zz-common/zz-ui/lib/style/mixins/ellipsis.scss';

  .new-qc-report-detail {
    margin-top: 18px;
    padding: 0 32px 32px;
    background: #fff;
    border-radius: 16px;

    .qc-report-unscramble {
      margin: 49px 0 0;

      .unscramble-list {
        position: relative;
        box-sizing: border-box;
        padding: 42px 0 0;

        &::after {
          @include hairline(#d8d8d8);
          border-top-width: 1px;
          border-top-style: dashed;
        }

        .unscramble_title {
          display: flex;
          align-items: center;
          margin-bottom: 28px;

          .title {
            @include ellipsis();
            max-width: 75%;
            color: #000;
            font-weight: 500;
            font-size: 28px;
            font-family: PingFangSC-Medium, PingFang SC;
            line-height: 28px;
          }

          .tag {
            @include border-1px(#ffae3c, 8px);
            box-sizing: border-box;
            margin-left: 8px;
            padding: 8px 12px;
            color: #ffae3c;
            font-weight: 400;
            font-size: 20px;
            font-family: PingFangSC-Regular, PingFang SC;
          }
        }

        .unscramble_list_second {
          box-sizing: border-box;
          padding: 20px 24px;
          font-weight: 400;
          font-size: 20px;
          font-family: PingFangSC-Regular, PingFang SC;
          line-height: 34px;
          background: #f7f7f7;
          border-radius: 4px;

          .item-unscramble:not(:last-child) {
            margin-bottom: 16px;
          }

          label {
            color: #111111;
          }

          span {
            color: #999;
          }
        }
      }
    }
    .new-example-pics-wrap {
      position: relative;
      margin-top: 19px;
    }

    .tab-tips {
      margin-top: 11px;
      color: #999999;
      font-weight: 400;
      font-size: 20px;
      font-family: PingFangSC-Light;
      line-height: 28px;
    }

    .tab-desc {
      box-sizing: border-box;
      width: 100%;
      margin-top: 16px;
      padding: 14px 24px;
      color: #999999;
      font-weight: 400;
      font-size: 20px;
      font-family: PingFangSC-Light;
      line-height: 24px;
      background: #f7f7f7;
      border-radius: 4px;
    }

    ul.example-pics {
      padding: 5px 0;
      overflow-x: auto;
      font-size: 0;
      white-space: nowrap;
      -webkit-overflow-scrolling: touch;

      li {
        display: inline-block;
        width: 120px;
        height: 120px;
        margin-right: 7px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        border-radius: 4px;
      }

      li:last-child {
        margin-right: 0;
      }
    }

    dl.qc-item-sec {
      color: #999;
      font-weight: 400;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      line-height: 20px;

      dt {
        margin-bottom: 24px;
        color: #111;
      }

      dd {
        margin-bottom: 24px;
      }

      dd.abnormal-show {
        div:last-child {
          margin-bottom: 0 !important;
        }
      }
    }

    dl.qc-item-sec:first-child {
      padding-top: 24px;
    }

    dl.qc-item-sec:last-child {
      dd:last-child {
        margin-bottom: 0;

        .sItem:last-child {
          .value-item {
            margin-bottom: 0;
          }
        }
      }
    }

    .new_qcWiki_desc {
      margin-bottom: 32px !important;
      padding: 20px 24px;
      color: #999999;
      font-weight: 400;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      line-height: 28px;
      background: #f7f7f7;
      border-radius: 4px;

      .tips {
        margin-top: 16px;
        color: #42a0ff;
        font-weight: 400;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        line-height: 20px;
      }
    }

    .content-wrap-antoggle {
      .qc-item-sec:last-child {
        .qcWiki_desc {
          margin-bottom: 0 !important;
        }
      }
    }

    .error_item_title {
      margin-bottom: 24px;
      color: #111;
    }

    .feedback-wrapper {
      padding-top: 30px;

      .feedback-content {
        position: relative;
        left: -24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        width: 646px;
        margin-bottom: -2px;
        padding: 30px 29px 0 24px;
        color: #111111;
        font-weight: 400;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;

        &::after {
          @include hairline(#f0f0f0);
          border-top-width: 1px;
        }

        span {
          display: flex;
          align-items: center;
        }

        img {
          width: 24px;
          height: 24px;
          margin-right: 6px;
        }
      }
    }
  }
</style>
